var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.06465 10.0615C3.06465 6.19726 6.19726 3.06465 10.0615 3.06465C13.9258 3.06465 17.0584 6.19726 17.0584 10.0615C17.0584 13.9258 13.9258 17.0584 10.0615 17.0584C6.19726 17.0584 3.06465 13.9258 3.06465 10.0615ZM10.0615 1C5.05698 1 1 5.05698 1 10.0615C1 15.0661 5.05698 19.123 10.0615 19.123C11.9419 19.123 13.6886 18.5503 15.1365 17.5697L20.0629 22.4961C20.7348 23.168 21.8242 23.168 22.4961 22.4961C23.168 21.8242 23.168 20.7348 22.4961 20.0629L17.5697 15.1365C18.5503 13.6886 19.123 11.9419 19.123 10.0615C19.123 5.05698 15.0661 1 10.0615 1Z","fill":"currentColor"}));
}

IconSearch.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
